module.exports = __webpack_public_path__ + "static/media/ic_eclipse.eabeea8c.svg";